import React, { useEffect } from 'react';
import { useForm } from '../../molecules/Form';
import Form from '../../molecules/Form/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import { AddUserModalWrapper } from './AddUserModal.style';
import Select from '../../molecules/Select';
import Toast from '../../molecules/Toast';
import userService from '../../../services/userService';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import { getCookie } from '../../../helpers/common';

export const UserTypes = [
  {
    value: 'manager',
    label: 'Manager',
  },
  {
    value: 'owner',
    label: 'Owner',
  },
  {
    value: 'employee',
    label: 'Employee',
  },
];
export const Status = [
  {
    value: 'Active',
    label: 'Active',
  },
  {
    value: 'Inactive',
    label: 'Inactive',
  },
];

const AddUserModal = ({ onSubmit, onClose, isEdit, data }) => {
  const [form] = useForm();
  const { refetch, user } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
    user: v.user,
  }));
  console.log(user);
  async function handelSubmit(e) {
    if (isEdit) {
      // In case of editing user this will render
      const userId = isEdit?._id;
      const payload = {
        first_name: e?.firstName,
        last_name: e?.lastName,
        store_id: data?.storeData?._id,
        business_id: data?.storeData?.business_id,
        email: e?.email,
      };
      try {
        await userService.updateUser(userId, payload);
        Toast({
          message: 'User Created Successfully',
          type: 'success',
        });
        refetch();
        onSubmit();
        onClose();
      } catch (error) {
        Toast({
          type: 'error',
          message: error?.message,
        });
      }
    } else {
      // In case of creating user this will render
      const payload = {
        first_name: e?.firstName,
        last_name: e?.lastName,
        store_id: data?.storeData?._id,
        business_id: data?.storeData?.business_id,
        email: e?.email,
        type: e?.type?.value,
        password: e?.password,
        ...(getCookie('_type') === 'merchant' && { merchant_id: user?._id }),
      };
      try {
        await userService.createUser(payload);
        Toast({
          message: 'User Created Successfully',
          type: 'success',
        });
        refetch();
        onSubmit();
        onClose();
      } catch (error) {
        Toast({
          type: 'error',
          message: error?.message,
        });
      }
    }
  }
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        firstName: isEdit?.first_name,
        lastName: isEdit?.last_name,
        email: isEdit?.email,
      });
    }
  }, [isEdit, form]);

  return (
    <>
      <AddUserModalWrapper>
        <Form form={form} onSubmit={handelSubmit}>
          <div className="input-wrap">
            <Form.Item
              type="text"
              name="firstName"
              sm
              rounded
              placeholder="Enter First Name"
              label="First Name"
              rules={[
                {
                  required: true,
                  message: 'First Name is Required',
                },
              ]}>
              <Field maxLength={40} />
            </Form.Item>

            <Form.Item
              type="text"
              name="lastName"
              sm
              rounded
              placeholder="Enter Last Name"
              label="Last Name"
              rules={[
                {
                  required: true,
                  message: 'Last Name is Required',
                },
              ]}>
              <Field maxLength={40} />
            </Form.Item>
          </div>
          <div className="input-wrap">
            <Form.Item
              type="text"
              name="email"
              sm
              rounded
              placeholder="Enter Email Address"
              label="Email Address"
              disabled={isEdit}
              rules={[
                {
                  email: true,
                },
                {
                  required: true,
                },
              ]}>
              <Field />
            </Form.Item>

            {!isEdit && (
              <Form.Item
                type="text"
                name="type"
                sm
                rounded
                placeholder="Select Type"
                label="Type"
                options={UserTypes}
                menuPosition="fixed"
                rules={[
                  {
                    required: true,
                    message: 'Type is Required',
                  },
                ]}>
                <Select />
              </Form.Item>
            )}
          </div>
          {!isEdit && (
            <div className="input-wrap">
              <Form.Item
                type="password"
                name="password"
                sm
                rounded
                placeholder="Enter Password"
                label="Password"
                rules={[
                  {
                    required: true,
                  },
                  { password: true },
                  {
                    pattern: /^.{8,64}$/,
                    message: 'Minimum Character Length is 8 and Maximum Character Length is 64',
                  },
                ]}>
                <Field maxLength={40} />
              </Form.Item>

              <Form.Item
                type="password"
                name="confirmPassword"
                sm
                rounded
                placeholder="Re-Enter Password"
                label="Confirm Password"
                rules={[
                  {
                    required: true,
                  },
                  {
                    password: true,
                  },
                  {
                    transform: value => value !== form.getFieldValue('password'),
                    message: 'The two passwords that you entered do not match!',
                  },
                ]}>
                <Field maxLength={40} />
              </Form.Item>
            </div>
          )}

          <div>
            <Button width="184px">{isEdit ? 'Save Changes' : 'Add User'}</Button>
          </div>
        </Form>
      </AddUserModalWrapper>
    </>
  );
};

export default AddUserModal;
